export class EmployeeUserEditModel {
    constructor() {
        this.userName = "";
        this.userRoles = [];
    }
}
export default class EmployeeUser extends EmployeeUserEditModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
